import React, { useState } from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const About = () => {
  const [showTeam, setShowTeam] = useState(false);
  const team = [
    { name: "Arun Kumar", role: "Lead Developer", bio: "Arun is an experienced full-stack developer with a passion for creating scalable web applications.", avatar: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" },
    { name: "Divya Patel", role: "UI/UX Designer", bio: "Divya specializes in crafting intuitive and visually appealing user interfaces.", avatar: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" },
    { name: "Rahul Sen", role: "Product Manager", bio: "Rahul drives product innovation with a focus on user needs and market trends.", avatar: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" },
  ];

  return (
    <div className="bg-gradient-to-b from-orange-50 to-yellow-50 text-gray-800 font-sans min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <section className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-8 flex items-center gap-3 animate-slide-in-top">
          <UserGroupIcon className="w-8 h-8 text-orange-600" />
          About Us
        </h1>
        <p className="text-center text-lg sm:text-xl text-gray-600 mb-10 animate-fade-in">
          We are a dedicated team committed to promoting fireworks safety and creating community-focused digital solutions. Our mission is to educate and empower users to enjoy celebrations responsibly while fostering innovation in web experiences.
        </p>
        <div className="flex justify-center mb-8">
          <button
            onClick={() => setShowTeam(!showTeam)}
            className="px-6 py-3 bg-orange-600 text-white rounded-full hover:bg-orange-700 transition duration-300 text-base sm:text-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            {showTeam ? 'Hide Team' : 'Meet Our Team'}
          </button>
        </div>
        {showTeam && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 animate-slide-in">
            {team.map((member, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded-xl shadow-lg flex items-start space-x-4 transform transition-all duration-500 hover:scale-105"
                style={{ animationDelay: `${idx * 0.15}s` }}
              >
                <svg className="w-8 h-8 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d={member.avatar} />
                </svg>
                <div>
                  <p className="text-base sm:text-lg text-gray-800 font-semibold">{member.name}</p>
                  <p className="text-sm text-gray-600">{member.role}</p>
                  <p className="text-sm text-gray-500 mt-1">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default About;
